import img from './BB-Preloader-3fach-komprimiert.gif';

export default function Loading() {
  return (
    <div>
      <img src={img} />
    </div>
  );
}
